/**
 * Foco programático (§15.2.1–§15.2.2): todo foco movido pelo app passa por `focusIfKeyboard`, que só age com a
 * modalidade de teclado ligada (`ui.keyboard`). Exceção: diálogos (§15.2.5) focam com qualquer modalidade e não usam
 * este utilitário. Nunca por chegada de dado, evento ao vivo, troca de cena ou toast (regra 1 de §15.2.2).
 */
import { ui } from '../state/store';
import { reducedMotion } from './useReducedMotion';

export interface FocusOptions {
  /** Rola o elemento para a vista (`block: 'nearest'`); padrão true. */
  scroll?: boolean;
}

/**
 * Com a modalidade de teclado ligada: `el.focus({ preventScroll: true })` e, com `scroll`, `scrollIntoView` suave (ou
 * imediato com movimento reduzido). Devolve true se focou.
 */
export function focusIfKeyboard(el: HTMLElement | null | undefined, opts: FocusOptions = {}): boolean {
  if (!el || !ui.value.keyboard) return false;
  el.focus({ preventScroll: true });
  if (opts.scroll ?? true) {
    el.scrollIntoView?.({ block: 'nearest', behavior: reducedMotion.value ? 'auto' : 'smooth' });
  }
  return true;
}
